<template>
  <div id="app">
    <nav-bar/>
    <main role="main">
      <es-notification v-if="isOpen"/>
      <router-view/>
    </main>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import NotificationManager from '@/mixins/NotificationManager';
import EsNotification from '@/components/EsNotification.vue';

export default {
  name: 'App',
  mixins: [NotificationManager],
  components: {
    NavBar,
    EsNotification,
  },
  data() {
    return {
      navExpanded: true,
    };
  },
};
</script>

<style lang="sass" scoped>
  main
    padding-top: calc(2.9rem + 80px)
</style>
